import { ExtractionReviewProvider } from "./extraction-review-context.js";
import { ExtractionReviewDrawer } from "./ExtractionReviewDrawer.js";
import { ExtractionReviewFloater } from "./ExtractionReviewFloater.js";

import type { ReactNode } from "react";

/** Authenticated-shell host: context + Ideation-only Review CTA + Sheet. */
export function ExtractionReviewHost({ children }: { children: ReactNode }) {
  return (
    <ExtractionReviewProvider>
      {children}
      <ExtractionReviewFloater />
      <ExtractionReviewDrawer />
    </ExtractionReviewProvider>
  );
}
